import { Reveal, SectionHeading } from "./Reveal";
import { scrollToId } from "../lib/scroll";
import { ArrowUpRight } from "lucide-react";

const THEMES = [
  {
    title: "Transitions de vie",
    text: "Reconversion, bilan d'étape, page à tourner : remettre du sens et du mouvement là où tout semble figé.",
  },
  {
    title: "Surcharge mentale & stress",
    text: "Quand la tête déborde : des outils concrets pour retrouver de l'espace, du sommeil et de la clarté.",
  },
  {
    title: "Haut potentiel & hypersensibilité",
    text: "Comprendre enfin votre fonctionnement — HPI, HPE — et transformer ce qui pèse en véritable levier.",
  },
  {
    title: "EMDR, EFT & libération émotionnelle",
    text: "Dépasser les traumatismes et les blocages qui résistent à la seule volonté, avec des approches validées.",
  },
];

export default function IndividuelSection() {
  return (
    <section id="individuel" data-testid="individuel-section-container" className="relative py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-3xl">
          <SectionHeading
            overtitle="Accompagnement individuel"
            title="Un espace confidentiel, rien qu'à vous."
          />
          <Reveal delay={0.2}>
            <p className="mt-6 text-base sm:text-lg text-slate-400 leading-relaxed">
              Dirigeant, manager, ou simplement humain en quête d'équilibre : chaque accompagnement
              est sur mesure, à votre rythme, sans jugement. Le premier rendez-vous — un diagnostic
              offert — permet d'établir ensemble votre besoin et son urgence.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 divide-y divide-[#D4AF37]/10 border-y border-[#D4AF37]/10">
          {THEMES.map((t, i) => (
            <Reveal key={t.title} delay={i * 0.08} y={20}>
              <button
                data-testid={`individuel-theme-${i}`}
                onClick={() => scrollToId("#contact")}
                className="group w-full grid sm:grid-cols-[80px_1fr_auto] items-center gap-4 sm:gap-8 py-8 text-left transition-colors duration-300"
              >
                <span className="font-mono-accent text-sm text-[#D4AF37]/60">0{i + 1}</span>
                <span>
                  <span className="font-serif-display block text-2xl sm:text-3xl text-white transition-colors duration-300 group-hover:text-[#F3E5AB]">
                    {t.title}
                  </span>
                  <span className="mt-2 block max-w-2xl text-sm sm:text-base text-slate-400 leading-relaxed">
                    {t.text}
                  </span>
                </span>
                <ArrowUpRight
                  size={26}
                  className="justify-self-end text-slate-600 transition-all duration-300 group-hover:text-[#D4AF37] group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
